module.exports = __webpack_public_path__ + "static/media/RP-37.b1b06934.pdf";